import { useQuery } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

interface IUseGetOfficePlanDetailOptions {
  refetchOnWindowFocus?: boolean;
  enabled?: boolean;
}

export const useGetOfficePlanDetail = (
  planId?: string,
  officeId?: string,
  options?: IUseGetOfficePlanDetailOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_OFFICE_PLAN_DETAIL', planId, officeId],
    queryFn: async () => PermanentJobsService.getOfficePlanDetail(planId!, officeId),
    retry: false,
    enabled: options?.enabled !== false && !!planId,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
